import { render } from "./TriviaCarousel.vue?vue&type=template&id=3141d6e0&scoped=true"
import script from "./TriviaCarousel.vue?vue&type=script&lang=js"
export * from "./TriviaCarousel.vue?vue&type=script&lang=js"

import "./TriviaCarousel.vue?vue&type=style&index=0&id=3141d6e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3141d6e0"]])

export default __exports__